"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3325],{

/***/ 43325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

const IconNavHelp = () => {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z", fill: "#2D2E2E" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12.0098 18.25C12.7001 18.25 13.2598 17.6904 13.2598 17C13.2598 16.3096 12.7001 15.75 12.0098 15.75C11.3194 15.75 10.7598 16.3096 10.7598 17C10.7598 17.6904 11.3194 18.25 12.0098 18.25Z", fill: "#2D2E2E" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M12.3599 6.13C11.1799 6.12 10.1699 6.43 9.37988 6.8V8.78C9.99988 8.38 11.0299 7.88 12.2999 7.88C12.3199 7.88 12.3299 7.88 12.3499 7.88C13.6499 7.89 14.4199 8.6 14.4899 9.26C14.5699 10.14 13.5299 10.93 11.8399 11.27L11.1399 11.41L11.1499 14.49H12.8999V12.81C15.5399 12.05 16.3699 10.43 16.2399 9.08C16.0599 7.4 14.4299 6.15 12.3599 6.13Z", fill: "#2D2E2E" })));
};
/* harmony default export */ __webpack_exports__["default"] = (IconNavHelp);
//# sourceMappingURL=navHelp.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)


/***/ })

}]);